export default function Credits() {
  return (
    <div className="Credits">
      <p className="credits">
        This project was coded by Paula Belloch. It is{" "}
        <a href="https://github.com/Pabelara/Dictionary-App">open-sourced</a>{" "}
        and is hosted on{" "}
        <a href="https://mystifying-jackson-c5bed8.netlify.app/">Netlify</a>
      </p>
    </div>
  );
}
